import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Page } from "src/app/model/Page";
import { PaymentSettlementModel } from "src/app/model/PaymentSettlementModel";
import { PaymentSettlementService } from "src/app/services/payment-settlement.service";

@Component({
  selector: "app-secure-appeal-hearing",
  templateUrl: "./appeal-hearing.component.html",
  styleUrls: ["./appeal-hearing.component.scss"],
})
export class AppealHearingComponent implements OnInit {
  lotteryList: PaymentSettlementModel[] = [];
  loaded: boolean = false;
  loaded1: boolean = false;
  statusList: any[] = [
    { name: "PENDING", value: "PENDING" },
    { name: "ALLOWED FOR HEARING", value: "Allowed_For_Hearing" },
    // {
    //   name: "PAYMENT DEFAULTER APPROVED,PENDING FOR PAYMENT EXTENTION",
    //   value: "APPROVED_BY_APPLLATE_OFFICER",
    // },
    { name: "APPROVED ", value: "APPROVED" },
    { name: "REJECTED", value: "REJECTED" },
  ];
  selectedLotteryCode: string | null = null;
  page: Page<PaymentSettlementModel>;
  dataSource: MatTableDataSource<PaymentSettlementModel> =
    new MatTableDataSource();
  // form: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  lotterysName: { [key: number]: string };
  status: { [key: number]: string };
  lotteryEventId: number;
  statusId: string;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    // "transactionId",
    "applicantName",
    "schemaCode",
    "appealType",
    "applicationDrawStatus",
    "applicantStatus",
    "appealDate",

    // "transactionDate",
    "action",
  ];
  pageSizeOptions: number[] = [10, 25, 100];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private _snackBar: MatSnackBar,

    private route: ActivatedRoute,

    private paymentSettlementService: PaymentSettlementService
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(
        localStorage.getItem("app-secure-payment-settlement-filterText"),
        [Validators.required, Validators.minLength(3)]
      ),
      // lotterysName: new FormControl(null, [Validators.required]),
      applicantStatus: new FormControl(
        localStorage.getItem("appeal-view-status")
      ),
    });
    this.filterForm.controls["filterText"].setValue(null);
    // this.route.params.subscribe((params: Params) => {
    //   this.paymentSettlementService.initBoardName().subscribe(
    //     (data: any) => {
    //       this.loaded = true;

    //       if (data.status === "SUCCESS") {
    //         this.lotteryList = data.lotteryList2;
    //         console.log("data.lotteryName", this.lotteryList);
    //       } else {
    //         this.paymentSettlementService.errorToast(data.errorMessage);
    //       }
    //     },
    //     (error) => {
    //       this.paymentSettlementService.errorToast(
    //         error?.error?.errorMessage || error?.error?.message
    //       );
    //     }
    //   );
    // });

    // this.route.params.subscribe((params: Params) => {
    //   this.paymentSettlementService.initBoardName().subscribe(
    //     (data: any) => {
    //       this.loaded1 = true;

    //       if (data.status === "SUCCESS") {
    //         this.lotteryList = data.lotteryList;

    //         this.filterForm.patchValue({
    //           lotterysName: this.lotteryList.find(
    //             (l) =>
    //               l.key === +localStorage.getItem("appeal-view-lotterysName")
    //           ),
    //         });
    //       } else {
    //         this.paymentSettlementService.errorToast(data.errorMessage);
    //       }
    //     },
    //     (error) => {
    //       this.paymentSettlementService.errorToast(
    //         error?.error?.errorMessage || error?.error?.message
    //       );
    //     }
    //   );
    // });

    this.loadData();
  }
  // onLotteryChange(value: any) {
  //   this.lotteryEventId = value.key;

  //   localStorage.setItem(
  //     "appeal-view-lotterysName",
  //     this.lotteryEventId.toString()
  //   );
  //   this.loadData();
  // }
  loadData() {
    if (this.lotteryEventId !== null) {
      this.paymentSettlementService
        .getApplicantHearingList(
          localStorage.getItem("appeal-view-status"),

          this.currentPage,
          this.pageSize,
          this.filterForm.value.filterText
        )
        .subscribe(
          (page: any) => {
            this.loaded = true;
            console.log("Page ", page);
            this.page = page;

            // if (
            //   page.content.applicationNo !== null &&
            //   page.content.applicationNo !== ""
            // ) {
            if (page.content[0] !== null) {
              this.dataSource = new MatTableDataSource(page.content);
            } else {
              this.dataSource = new MatTableDataSource<PaymentSettlementModel>(
                []
              );
            }
            console.log("this.dataSource ", this.page);
            // } else {
            //   this.loaded = false;
            //   this.paymentSettlementService.errorToast(page.errorMessage);
            // }
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = page.totalElements;
            });
            this.isSearchDisabled = false;
          },
          (error) => {
            console.log(error);
            this.isSearchDisabled = false;
          }
        );
    } else {
      this.paymentSettlementService.errorToast("Please select Lottery");
    }
  }

  onStatusChange(value: any) {
    this.statusId = value;
    this.loaded = false;
    localStorage.setItem("appeal-view-status", this.statusId);

    this.loadData();
  }

  resetFilter() {
    // window.location.reload();
    // this.filterForm.controls["lotterysName"].setValue(null);

    this.filterForm.controls["applicantStatus"].setValue(null);

    this.filterForm.controls["filterText"].setValue(null);
    // this.filterForm.controls["status"].setValue(null);
    // this.filterForm.controls["lotterysName"].setValue(null);

    this.page = null;
    this.dataSource = new MatTableDataSource(null);
    setTimeout(() => {
      this.paginator.pageIndex = 0;
      this.paginator.length = 0;
    });
  }
  onSearch() {
    if (this.filterForm.valid) {
      this.page = null;
      this.dataSource = null;
      this.pageSize = 0;
      this.currentPage = 0;
      localStorage.setItem(
        "app-secure-payment-settlement-filterText",
        this.filterForm.value.filterText
      );

      this.onLoad();
    } else {
      this._snackBar.open(" Application Number is Required ", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      });
      this.isSearchDisabled = false;
    }
  }
  onLoad() {
    this.loaded = false;
    this.paymentSettlementService
      // .fetchPaymentSettlementList(
      //   this.currentPage,
      //   this.pageSize,
      //   this.filterForm.value.filterText
      // )
      .getApplicantHearingFilterList(
        // localStorage.getItem("appeal-view-lotterysName"),
        localStorage.getItem("appeal-view-status"),
        // this.filterForm.value.paymentStatus,
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (page: any) => {
          this.page = page;

          if (page.content && page.content.length !== 0) {
            this.dataSource = new MatTableDataSource(page.content);
          } else {
            this._snackBar.open(
              "Please Enter Valid Application Number ",
              "Close",
              {
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: "warning-toast",
                duration: 3 * 1000,
              }
            );
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
          this.loaded = false;
        },
        (error) => {
          console.log(error);
          this.loaded = false;
          this.isSearchDisabled = false;
        }
      );
  }

  // ngAfterViewInit(): void {
  //   this.dataSource.sort = this.sort;
  //   this.dataSource.paginator = this.paginator;
  // }

  pageChanged(event: PageEvent) {
    console.log({ event });
    console.log(event.pageSize);
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
}
